<template>
    <td-dialog
        :title="$t('pgCommon.SET_USER_ROLE')"
        :before-close="setRoleDialogClose"
        :visible.sync="setRoleVisible"
        width="800px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="10vh"
    >
        <el-container>
            <el-header>
                <el-form :inline="true" :model="fromRole" ref="fromRole" class="demo-form-inline" :rules="rules">
                    <el-row :gutter="20">
                        <el-col>
                            <td-permission :permissions="permissionsView">
                                <div slot="havePermission">
                                    <el-form-item :label="$t('common.ROLENAME')">
                                        <td-input placeholder="common.PLEASE_INPUT" v-model="fromRole.roleName"></td-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('common.ROLE_TYPE')">
                                        <td-select v-model="fromRole.roleType" :placeholder="$t('common.PLEASE_SELECT')" :options="roleTypeList" keys="iTypeId" text="sName"> </td-select>
                                    </el-form-item>
                                </div>
                            </td-permission>
                            <el-form-item class="paddingLeft10">
                                <td-button type="primary" :permissions="permissionsView" :loading="queryLoading" @click.native="queryPageList()">{{ $t('common.QUERY') }}</td-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-header>
            <el-main>
                <!-- 加载表格 -->
                <td-table
                    :hasPageMemory="true"
                    ref="tdtable"
                    :height="500"
                    :columns="columns"
                    :permissions="permissionsView"
                    :dataSource="tableData"
                    :pageSize="pageSize"
                    :currentPage="currentPage"
                    :total="total"
                    rowKey="roleId"
                    :hasLoading="loading"
                    @handleSizeChange="handleSizeChange"
                    @currentChange="currentChange"
                    @selection-change="handleSelect"
                ></td-table>
            </el-main>
        </el-container>
        <span slot="footer" style="text-align:left">
            <td-button type="primary" :loading="saveLoading" @click="saveRole">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="setRoleDialogClose">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import Api from './../assets/api.js';
export default {
    props: ['setRoleVisible', 'setRoleInfo', 'templateKey'],
    created() {
        //查询回显数据
        this.queryFeedBack();
        if (this.$common.systemInfo.systemId) {
            this.sysFlg = this.$common.systemInfo.systemId;
        } else {
            this.sysFlg = 'PG';
        }
    },
    mounted() {},
    data() {
        return {
            fromRole: {
                roleName: '',
                roleType: ''
            },
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            saveLoading: false,
            queryLoading: false,
            permissionsView: window.pangu.common.permissionsView,
            roleTypeList: [],
            sysFlg: '',
            selectedData: [], //回显的数据
            currentSelectedData: [], //当前选择的数据
            currentSelectedName: [], //当前选择的数据名称
            columns: [
                {
                    prop: 'roleName',
                    label: this.$t('common.ROLENAME')
                },
                {
                    prop: 'roleTypeName',
                    label: this.$t('common.ROLE_TYPE')
                },
                {
                    prop: 'roleDescription',
                    label: this.$t('common.DESCRIPTION')
                }
            ]
        };
    },
    methods: {
        //查询角色类型
        findRoleType() {
            this.roleTypeList = [];
            Api.queryAllRoleType('{}', response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('roleType/queryAllRoleType', response.data.statusMessage);
                    return;
                }
                if (!this.$util.isEmpty(response.data.content)) {
                    for (let i = 0; i < response.data.content.length; i++) {
                        const element = response.data.content[i];
                        if (element.iTypeId != 1) {
                            this.roleTypeList.push(element);
                        }
                    }
                    this.fromRole.roleType = window.pangu.common.roleType.ordinaryRole; //普通角色
                    this.queryPageList(); // 进行页面初始化数据的加载
                }
            });
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryPageList();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.btnQuery();
        },
        queryPageList() {
            this.currentPage = 1;
            this.btnQuery();
        },
        //查询角色
        btnQuery() {
            this.loading = true;
            this.queryLoading = true;
            let param = {
                sysFlg: this.sysFlg,
                roleName: this.fromRole.roleName,
                roleType: this.fromRole.roleType,
                currentPage: this.currentPage,
                pageSize: this.pageSize,
                excludeRoleTypeIds: [window.pangu.common.roleType.orgRole] //组织角色
            };
            Api.getRoleAuthList(JSON.stringify(param), response => {
                this.queryLoading = false;
                this.loading = false;
                if (this.$t(this.$common.requestCode.SUCCESS_INFO_CODE) != response.data.statusCode) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('role/getRoleAuthList', response.data.statusMessage);
                    return;
                }
                let data = response.data.content;
                this.tableData = data;
                this.total = response.data.count;
                this.loading = false;
                this.feedBack(this.selectedData);
            });
        },
        // 回显
        feedBack(data) {
            this.$nextTick(() => {
                if (!this.$util.isEmpty(data)) {
                    data.forEach(ele => {
                        this.tableData.forEach(element => {
                            if (ele == element.roleId) {
                                this.$refs.tdtable.toggleRowSelection(element, true);
                            }
                        });
                    });
                }
            });
        },
        //处理取消的节点
        handleSelect(selection) {
            let userArr = [];
            let nameArr = [];
            for (let item in this.tableData) {
                userArr.push(this.tableData[item].roleId);
                nameArr.push(this.tableData[item].roleName);
            }
            for (let item in selection) {
                if (userArr.indexOf(selection[item].roleId) > -1) {
                    userArr.splice(userArr.indexOf(selection[item].roleId), 1);
                    nameArr.splice(userArr.indexOf(selection[item].roleName), 1);
                }
            }
            for (let item in this.currentSelectedData) {
                for (let userItem in userArr) {
                    if (userArr[userItem] == this.currentSelectedData[item]) {
                        this.currentSelectedData.splice(item, 1);
                        this.currentSelectedName.splice(item, 1);
                    }
                }
            }
            for (let item in selection) {
                if (this.currentSelectedData.indexOf(selection[item].roleId) == -1) {
                    this.currentSelectedData.push(selection[item].roleId);
                    this.currentSelectedName.push(selection[item].roleName);
                }
            }
        },
        //保存角色
        saveRole() {
            let data = this.$refs.tdtable.getSelectAllRows();
            data.forEach(ele => {
                let flag = false;
                this.currentSelectedData.forEach(element => {
                    if (element == ele.roleId) {
                        flag = true;
                    }
                });
                if (!flag) {
                    this.currentSelectedData.push(ele.roleId);
                    this.currentSelectedName.push(ele.roleName);
                }
            });
            this.saveLoading = true;
            let roleIdStr = '';
            let roleNameStr = '';
            if (this.currentSelectedData != null && this.currentSelectedData.length > 0) {
                if (this.currentSelectedData.length > 40) {
                    this.$message({ showClose: true, message: this.$t('pgCommon.CANT_SELECT_40'), type: 'warning' });
                    return;
                }
                for (let obj in this.currentSelectedData) {
                    let roleId = this.currentSelectedData[obj];
                    let roleName = this.currentSelectedName[obj];
                    if (roleIdStr === '') {
                        roleIdStr += roleId;
                        if (undefined != roleName) {
                            roleNameStr += roleName;
                        } else {
                            roleNameStr += this.$t('pgCommon.NOT_HAVE');
                        }
                    } else {
                        roleIdStr += ',' + roleId;
                        if (undefined != roleName) {
                            roleNameStr += ',' + roleName;
                        } else {
                            roleNameStr += ',' + this.$t('pgCommon.NOT_HAVE');
                        }
                    }
                }
            }
            if (!this.currentSelectedData.length || this.currentSelectedData.length == 0) {
                roleIdStr = "null";
            }
            let param = {
                processDefKey: this.templateKey,
                taskDefKey: this.setRoleInfo.taskKey,
                userRoleIds: roleIdStr,
                userRoleNames: roleNameStr,
                flag: this.setRoleInfo.tasksFlag
            };
            Api.saveNodeUser(JSON.stringify(param), response => {
                this.saveLoading = false;
                if (this.$t(this.$common.requestCode.SUCCESS_INFO_CODE) != response.data.statusCode) {
                    this.loading = false;
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('role/getRoleAuthList', response.data.statusMessage);
                    return;
                }
                this.$message({ showClose: true, message: this.$t('pgCommon.ADD_SUCCESS'), type: 'success' });
                this.setRoleDialogClose();
            });
        },
        // 查询回显数据
        queryFeedBack() {
            this.loading = true;
            let param = {
                sId: this.templateKey + this.setRoleInfo.taskKey,
                processDefKey: this.templateKey,
                taskDefKey: this.setRoleInfo.taskKey
            };
            Api.queryNodeUser(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    this.$log.error('queryNodeUser', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('queryNodeUser', response.data.statusMessage);
                    return;
                }
                if (response.data.content.length > 0) {
                    let roleStr = response.data.content[0].userRoleIds;
                    if (null != roleStr && '' != roleStr) {
                        this.selectedData = [];
                        this.selectedData = roleStr.split(',');
                    }
                }
                //查询角色
                this.findRoleType();
                this.loading = false;
            });
        },
        //关闭
        setRoleDialogClose() {
            this.$emit('setRoleDialogClose');
        }
    }
};
</script>
